import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    baseurl:'119.45.200.53',
    SSResult_active:false
  },
  getters: {
  },
  mutations: {
    CHANGESSRESULT(state){
      state.SSResult_active=!state.SSResult_active
    }
  },
  actions: {
  },
  modules: {
  }
})
